import { post, getF2BObject } from 'api/api';
import { API } from '../consts';
import { GuestRegistration, Role } from './types/auth';
import { OwnerDetail } from './types/owner';
import { BASE_URL, useFetch, post as newPost, get as newGet } from 'utils/sdk';

// TODO: Remove
const getRandomPassword = () =>
  '1aA' +
  Array.from(new Array(16))
    .map(() => String.fromCharCode(Math.random() * 86 + 40))
    .join('');

export const createAnonymousSession = () => {
  const password = getRandomPassword();
  return post<GuestRegistration>('/services/guest/', {
    isAnonymous: true,
    isActive: true,
    password,
  }).then(({ data: { email } }) => newLogin(email, password));
};
// ============================================================

export const createOwner = ({
  firstName,
  email,
  password,
  phone,
  marketingCheckbox,
  captchaToken,
}) => {
  const payload = { firstName, email, password, isActive: true, captchaToken } as any;
  const onboardingData = { phone, marketingCheckbox };
  payload.onboardingData = onboardingData;
  return post('/services/owner/', payload);
};

export const socialLoginOrCreateOwner = (platform, params = {}) => {
  const urlParams = params as any;
  const parsedParams = getF2BObject(urlParams);
  const queryParams = new URLSearchParams(parsedParams).toString();
  const url = `${API.root}auth/login/${platform}/${queryParams ? `?${queryParams}` : ''}`;
  window.location.href = url;
};

export const disconnectSocialProvider = (payload = {}) => {
  const url = '/auth/disconnect-backend/';
  return post(url, payload);
};
// ========= NEW AUTH APIS ============
interface JwtResponse {
  token: string;
}

export const newLogin = (email, password) => {
  const url = `${BASE_URL}jwt/login/`;
  const response = newPost<JwtResponse>(url, {
    email,
    password,
  });

  return response.then((res) => {
    localStorage.setItem('token', res.token);
    return res;
  });
};

export const requestMagicLink = ({ email }: { email: string }) =>
  newPost(`${BASE_URL}jwt/magic-link/request/`, { email });

export const consumeMagicLink = ({ token }: { token: string }) =>
  newPost<JwtResponse>(`${BASE_URL}jwt/magic-link/consume/`, { token }).then((res) => {
    localStorage.setItem('token', res.token);
    return res;
  });

export const newLogout = () => {
  return newPost<OwnerDetail>(`${BASE_URL}jwt/logout/`).finally(() => {
    localStorage.removeItem('token');
  });
};

export interface MeResponse {
  user_id: number;
  owner_id?: number;
  email: string;
  role: Role;
  is_masqueraded: boolean;
  is_cohost: boolean;
  cohost_id: number | null;
}
export const fetchMe = () => {
  return newGet<MeResponse>(`${BASE_URL}jwt/me/`, {});
};

export const useSignedUser = () => useFetch<MeResponse>('jwt/me/');

// `useSignedUser` fires on mount with or without a token, so it 401s on public routes. Use this
// where the user is only wanted if already signed in - `isLoading` stays true when there is no token.
export const useSignedUserIfLoggedIn = () =>
  useFetch<MeResponse>(localStorage.getItem('token') ? 'jwt/me/' : undefined);

// ==========================================
